// src/utils/validConst.js
/**
 * 常量（与后端ValidConst.java保持一致）
 */
export const ValidConst = {
    // 邮箱正则
    EMAIL_REG: /^(?!.*[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef])[a-zA-Z0-9](?:[a-zA-Z0-9._-]{0,62}[a-zA-Z0-9])?@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.(?:com|cn|net)$/i,
    EMAIL_MSG: '请输入符合规范的邮箱地址',

    // 手机号正则（11位，后8位不能连续重复）
    PHONE_REG: /^1(?:3[0-9]|4[01456789]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-9])(?!(\d)\1{7})\d{8}$/,
    PHONE_MSG: '请输入11位有效手机号',

    // 密码正则（8-20位，数字+字母必含、无中文、允许标点/符号）
    PWD_REG: /^(?=.*[0-9])(?=.*[a-zA-Z])[^\u4e00-\u9fa5]{8,20}$/,
    PWD_MSG: '密码须8-20位，包含字母、数字',

    // 验证码正则（6位数字）
    CODE_REG: /^\d{6}$/,
    CODE_MSG: '验证码须为6位数字'
}

//Element Plus所有图标
export const IconList = {
    // ========== 常用导航类 ==========
    Menu: { label: '菜单' },
    Folder: { label: '文件夹' },
    FolderOpened: { label: '打开的文件夹' },
    FolderAdd: { label: '添加文件夹' },
    Document: { label: '文档' },
    DocumentAdd: { label: '添加文档' },
    Files: { label: '文件组' },
    User: { label: '用户' },
    UserFilled: { label: '填充用户' },
    HomeFilled: { label: '填充首页' },
    Setting: { label: '设置' },
    Message: { label: '消息' },
    MessageBox: { label: '消息框' },
    Notification: { label: '通知' },
    Bell: { label: '铃铛' },
    BellFilled: { label: '填充铃铛' },
    Monitor: { label: '监控' },
    Management: { label: '管理' },

    // ========== 不常用的关掉，数据太多 页面加载变慢 常用操作类 ==========
    // Search: { label: '搜索' },
    // Edit: { label: '编辑' },
    // EditPen: { label: '编辑笔' },
    // Delete: { label: '删除' },
    // DeleteFilled: { label: '填充删除' },
    // Refresh: { label: '刷新' },
    // AddLocation: { label: '添加位置' },
    // CirclePlus: { label: '圆形加号' },
    // CirclePlusFilled: { label: '填充圆形加号' },
    // Upload: { label: '上传' },
    // UploadFilled: { label: '填充上传' },
    // Download: { label: '下载' },
    // Check: { label: '勾选' },
    // Checked: { label: '已勾选' },
    //
    // // ========== 常用状态类 ==========
    // SuccessFilled: { label: '填充成功' },
    // WarningFilled: { label: '填充警告' },
    // Warning: { label: '警告' },
    // WarnTriangleFilled: { label: '填充警告三角' },
    // Failed: { label: '失败' },
    // Close: { label: '关闭' },
    // CloseBold: { label: '粗体关闭' },
    // InfoFilled: { label: '填充信息' },
    // QuestionFilled: { label: '填充问号' },
    //
    // // ========== 常用方向类 ==========
    // ArrowLeft: { label: '左箭头' },
    // ArrowLeftBold: { label: '粗体左箭头' },
    // ArrowRight: { label: '右箭头' },
    // ArrowRightBold: { label: '粗体右箭头' },
    // ArrowUp: { label: '上箭头' },
    // ArrowUpBold: { label: '粗体上箭头' },
    // ArrowDown: { label: '下箭头' },
    // ArrowDownBold: { label: '粗体下箭头' },
    // Back: { label: '返回' },
    //
    //
    //
    // // ========== 其余图标 ==========
    // Aim: { label: '瞄准' },
    // AlarmClock: { label: '闹钟' },
    // Apple: { label: '苹果' },
    // Avatar: { label: '头像' },
    // Baseball: { label: '棒球' },
    // Basketball: { label: '篮球' },
    // Bicycle: { label: '自行车' },
    // BottomLeft: { label: '左下' },
    // BottomRight: { label: '右下' },
    // Bottom: { label: '底部' },
    // Bowl: { label: '碗' },
    // Box: { label: '盒子' },
    // Briefcase: { label: '公文包' },
    // BrushFilled: { label: '填充画笔' },
    // Brush: { label: '画笔' },
    // Burger: { label: '汉堡' },
    // Calendar: { label: '日历' },
    // CameraFilled: { label: '填充相机' },
    // Camera: { label: '相机' },
    // CaretBottom: { label: '下三角符号' },
    // CaretLeft: { label: '左三角符号' },
    // CaretRight: { label: '右三角符号' },
    // CaretTop: { label: '上三角符号' },
    // Cellphone: { label: '手机' },
    // ChatDotRound: { label: '圆形消息点' },
    // ChatDotSquare: { label: '方形消息点' },
    // ChatLineRound: { label: '圆形消息线条' },
    // ChatLineSquare: { label: '方形消息线条' },
    // ChatRound: { label: '圆形聊天' },
    // ChatSquare: { label: '方形聊天' },
    // CircleCheckFilled: { label: '填充圆形勾选' },
    // CircleCheck: { label: '圆形勾选' },
    // CircleCloseFilled: { label: '填充圆形关闭' },
    // CircleClose: { label: '圆形关闭' },
    // Clock: { label: '时钟' },
    // Cloudy: { label: '多云' },
    // CoffeeCup: { label: '咖啡杯' },
    // Coffee: { label: '咖啡' },
    // Coin: { label: '硬币' },
    // ColdDrink: { label: '冷饮' },
    // CollectionTag: { label: '收藏标签' },
    // Collection: { label: '收藏' },
    // Comment: { label: '评论' },
    // Compass: { label: '指南针' },
    // Connection: { label: '连接' },
    // Coordinate: { label: '坐标' },
    // CopyDocument: { label: '复制文档' },
    // Cpu: { label: '处理器' },
    // CreditCard: { label: '信用卡' },
    // Crop: { label: '裁剪' },
    // DArrowLeft: { label: '双左箭头' },
    // DArrowRight: { label: '双右箭头' },
    // DCaret: { label: '双三角符号' },
    // DataAnalysis: { label: '数据分析' },
    // DataBoard: { label: '数据面板' },
    // DataLine: { label: '数据线条' },
    // DeleteLocation: { label: '删除位置' },
    // Dessert: { label: '甜点' },
    // Discount: { label: '折扣' },
    // DishDot: { label: '菜品点' },
    // Dish: { label: '菜品' },
    // DocumentChecked: { label: '已勾选文档' },
    // DocumentCopy: { label: '复制文档' },
    // DocumentDelete: { label: '删除文档' },
    // DocumentRemove: { label: '移除文档' },
    // Drizzling: { label: '小雨' },
    // ElemeFilled: { label: '填充饿了么' },
    // Eleme: { label: '饿了么' },
    // ElementPlus: { label: 'Element Plus 标识' },
    // Expand: { label: '展开' },
    // Female: { label: '女性' },
    // Film: { label: '胶片/电影' },
    // Filter: { label: '筛选' },
    // Finished: { label: '完成' },
    // FirstAidKit: { label: '急救包' },
    // Flag: { label: '旗帜' },
    // Fold: { label: '折叠' },
    // FolderChecked: { label: '已勾选文件夹' },
    // FolderDelete: { label: '删除文件夹' },
    // FolderRemove: { label: '移除文件夹' },
    // Food: { label: '食物' },
    // Football: { label: '足球' },
    // ForkSpoon: { label: '叉子勺子' },
    // Fries: { label: '薯条' },
    // FullScreen: { label: '全屏' },
    // GobletFull: { label: '满杯高脚杯' },
    // GobletSquareFull: { label: '满杯方形高脚杯' },
    // GobletSquare: { label: '方形高脚杯' },
    // Goblet: { label: '高脚杯' },
    // GoldMedal: { label: '金牌' },
    // GoodsFilled: { label: '填充商品' },
    // Goods: { label: '商品' },
    // Grape: { label: '葡萄' },
    // Grid: { label: '网格' },
    // Guide: { label: '指南' },
    // Handbag: { label: '手提包' },
    // Headset: { label: '耳机' },
    // HelpFilled: { label: '填充帮助' },
    // Help: { label: '帮助' },
    // Hide: { label: '隐藏' },
    // Histogram: { label: '柱状图' },
    // HotWater: { label: '热水' },
    // House: { label: '房子' },
    // IceCreamRound: { label: '圆形冰淇淋' },
    // IceCreamSquare: { label: '方形冰淇淋' },
    // IceCream: { label: '冰淇淋' },
    // IceDrink: { label: '冰饮' },
    // IceTea: { label: '冰茶' },
    // Iphone: { label: '苹果手机' },
    // Key: { label: '钥匙' },
    // KnifeFork: { label: '刀叉' },
    // Lightning: { label: '闪电' },
    // Link: { label: '链接' },
    // List: { label: '列表' },
    // Loading: { label: '加载' },
    // LocationFilled: { label: '填充位置' },
    // LocationInformation: { label: '位置信息' },
    // Location: { label: '位置' },
    // Lock: { label: '锁定' },
    // Lollipop: { label: '棒棒糖' },
    // MagicStick: { label: '魔法棒' },
    // Magnet: { label: '磁铁' },
    // Male: { label: '男性' },
    // MapLocation: { label: '地图位置' },
    // Medal: { label: '奖牌' },
    // Memo: { label: '备忘录' },
    // Mic: { label: '麦克风（短称）' },
    // Microphone: { label: '麦克风（全称）' },
    // MilkTea: { label: '奶茶' },
    // Minus: { label: '减号' },
    // Money: { label: '钱' },
    // MoonNight: { label: '夜晚月亮' },
    // Moon: { label: '月亮' },
    // MoreFilled: { label: '填充更多' },
    // More: { label: '更多' },
    // MostlyCloudy: { label: '大部分多云' },
    // Mouse: { label: '鼠标' },
    // Mug: { label: '马克杯' },
    // MuteNotification: { label: '静音通知' },
    // Mute: { label: '静音' },
    // NoSmoking: { label: '禁止吸烟' },
    // Notebook: { label: '笔记本' },
    // Odometer: { label: '里程表' },
    // OfficeBuilding: { label: '办公楼' },
    // Open: { label: '打开' },
    // Operation: { label: '操作' },
    // Opportunity: { label: '机会' },
    // Orange: { label: '橙子' },
    // Paperclip: { label: '回形针' },
    // PartlyCloudy: { label: '部分多云' },
    // Pear: { label: '梨' },
    // PhoneFilled: { label: '填充电话' },
    // Phone: { label: '电话' },
    // PictureFilled: { label: '填充图片' },
    // PictureRounded: { label: '圆角图片' },
    // Picture: { label: '图片' },
    // PieChart: { label: '饼图' },
    // Place: { label: '地点' },
    // Platform: { label: '平台' },
    // Plus: { label: '加号' },
    // Pointer: { label: '指针' },
    // Position: { label: '定位' },
    // Postcard: { label: '明信片' },
    // Pouring: { label: '大雨' },
    // Present: { label: '礼物' },
    // PriceTag: { label: '价格标签' },
    // Printer: { label: '打印机' },
    // Promotion: { label: '促销' },
    // QuartzWatch: { label: '石英表' },
    // Rank: { label: '排名' },
    // ReadingLamp: { label: '阅读灯' },
    // Reading: { label: '阅读' },
    // RefreshLeft: { label: '向左刷新' },
    // RefreshRight: { label: '向右刷新' },
    // Refrigerator: { label: '冰箱' },
    // RemoveFilled: { label: '填充移除' },
    // Remove: { label: '移除' },
    // Right: { label: '右向' },
    // ScaleToOriginal: { label: '还原尺寸' },
    // School: { label: '学校' },
    // Scissor: { label: '剪刀' },
    // Select: { label: '选择' },
    // Sell: { label: '售卖' },
    // SemiSelect: { label: '半选' },
    // Service: { label: '服务' },
    // SetUp: { label: '设置（动词）' },
    // Share: { label: '分享' },
    // Ship: { label: '船' },
    // Shop: { label: '商店' },
    // ShoppingBag: { label: '购物袋' },
    // ShoppingCartFull: { label: '满购物车' },
    // ShoppingCart: { label: '购物车' },
    // ShoppingTrolley: { label: '购物手推车' },
    // Smoking: { label: '吸烟' },
    // Soccer: { label: '足球' },
    // SoldOut: { label: '售罄' },
    // SortDown: { label: '向下排序' },
    // SortUp: { label: '向上排序' },
    // Sort: { label: '排序' },
    // Stamp: { label: '印章' },
    // StarFilled: { label: '填充星星' },
    // Star: { label: '星星' },
    // Stopwatch: { label: '秒表' },
    // Sugar: { label: '糖' },
    // SuitcaseLine: { label: '线条行李箱' },
    // Suitcase: { label: '行李箱' },
    // Sunny: { label: '晴天' },
    // Sunrise: { label: '日出' },
    // Sunset: { label: '日落' },
    // SwitchButton: { label: '开关按钮' },
    // SwitchFilled: { label: '填充开关' },
    // Switch: { label: '开关' },
    // TakeawayBox: { label: '外卖盒' },
    // Ticket: { label: '票' },
    // Tickets: { label: '票组' },
    // Timer: { label: '计时器' },
    // ToiletPaper: { label: '卫生纸' },
    // Tools: { label: '工具' },
    // TopLeft: { label: '左上' },
    // TopRight: { label: '右上' },
    // Top: { label: '顶部' },
    // TrendCharts: { label: '趋势图' },
    // TrophyBase: { label: '奖杯底座' },
    // Trophy: { label: '奖杯' },
    // TurnOff: { label: '关闭' },
    // Umbrella: { label: '雨伞' },
    // Unlock: { label: '解锁' },
    // Van: { label: '货车' },
    // VideoCameraFilled: { label: '填充摄像机' },
    // VideoCamera: { label: '摄像机' },
    // VideoPause: { label: '视频暂停' },
    // VideoPlay: { label: '视频播放' },
    // View: { label: '查看' },
    // WalletFilled: { label: '填充钱包' },
    // Wallet: { label: '钱包' },
    // Watch: { label: '手表' },
    // Watermelon: { label: '西瓜' },
    // WindPower: { label: '风力' },
    // ZoomIn: { label: '放大' },
    // ZoomOut: { label: '缩小' }
};